import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    
        <Paper
          elevation={8}
          sx={{
            p: 0,
            borderRadius: 3,
            backgroundColor: 'background.paper',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Outlet />
        </Paper>
  );
};

export default AuthLayout;


